import React from 'react';
import { Row, Col } from 'react-bootstrap';

const Column = ({ field, children }) => {
  const { opts } = field || {};
  const { colProps, breakAfter } = opts || {};
  const props = colProps || { sm: 12 };
  if (breakAfter) {
    return (
      <Row>
        <Col {...props}>
          {children}
        </Col>
        <Col sm={12}></Col>
      </Row>
    )
  }
  return (
    <Col {...props}>
      {children}
    </Col>
  )
}

export default Column;



// WEBPACK FOOTER //
// ./src/components/routes/assets/asset-form/Column.js